import InputFilter from './InputFilter';
import { DeviceHelper, Device } from '../../Core/DeviceHelper';

const device = DeviceHelper.GetDevice();
const paggingRows = 4;

let paggingCols = 6; // Desktop
if (Device.Tablet === device) {
    // Tablet
    paggingCols = 3;
} else if (Device.Mobile === device) {
    // Mobile
    paggingCols = 3;
}

let maxItems = paggingCols * paggingRows;
export default class ObrasFilter {

    constructor(options) {
        const { region, zona, teatro, dia, source } = options;

        this.region = new InputFilter(region);
        this.zona = new InputFilter(zona);
        this.teatro = new InputFilter(teatro);
        this.dia = new InputFilter(dia);
        this.source = source;
        this.filteredSource = source;
    }

    showMore() {
        if (maxItems > this.filteredSource.length) return;
        maxItems += paggingCols * paggingRows; 
        this.fillSearch(false);
    }

    needMore() {
        return maxItems < this.filteredSource.length;
    }

    setRegion(value) {
        this.region.val(value);
    }

    setZona(value) {
        this.zona.val(value);
    }

    setTeatro(value) {
        this.teatro.val(value);
    }

    setDia(value) {
        this.dia.val(value);
    }

    clear() {
        this.region.val('');
        this.zona.val('');
        this.teatro.val('');
        this.dia.val('');
        maxItems = paggingCols * paggingRows;
    }

    fillSearch(hide = true) {
        this.filteredSource = this.source;
        if (hide) this.filteredSource.hide();
        if (this.region.val()) {
            this.filteredSource = this.filteredSource.filter(`[data-regiones~='${this.region.val()}']`);
        }
        if (this.zona.val()) {
            this.filteredSource = this.filteredSource.filter(`[data-zonas~='${this.zona.val()}']`);
        }
        if (this.teatro.data('all') !== true && this.teatro.val()) {
            this.filteredSource = this.filteredSource.filter(`[data-teatros~='${this.teatro.val()}']`);
        }
        if (this.dia.data('all') !== true && this.dia.val()) {
            this.filteredSource = this.filteredSource.filter(`[data-dias~='${this.dia.val()}']`);
        }
        let visibleItems = this.filteredSource;
        if (maxItems) {
            // Si es 0, no se filtra
            visibleItems = this.filteredSource.slice(0, maxItems);
        }

        visibleItems.fadeIn();
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Filters/ObrasFilter.js